module.exports = __webpack_public_path__ + "static/media/3655.8fb199dd.jpg";